// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b93499ff","396":"80a068ca","453":"6cdefbf4","455":"3865017d","977":"0dba1fbe"}[chunkId] + ".chunk.js";
};